import React from "react";
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Alert,
    AlertTitle
} from "@mui/material";
import Upload from "./Upload";
import LoadingReport from "./Loading";
import Toast from "../../components/Toast";
import { useSelector } from "react-redux";
import ReviewPage from "../billing/Validation";
import Page from '../../components/Page';
import { isWithinUploadLimit, uploadSizeErrorMessage } from '../../utils/uploadLimits';
import { useUploadFile, useUploadFileNoProcess, useFetchPolicyPdf } from '../../hooks/useFiles';
import { PLANS_PATH } from '../../permissions/viewRegistry';
import {
    canProceedWithPlanNaming,
    defaultNewPlanFileName,
    PLAN_NAMING_MESSAGES,
    validatePlanNaming,
} from '../../utils/planNamingUtils';

const FileUploader = () => {
    const navigate = useNavigate();
    /// File Upload page
    const user = useSelector((state)=> state.UserReducer.user);
    const customerSelect = useSelector((state) => state.UserReducer.customerSelection);

    const [jobName, setJobName] =  React.useState('');
    const [areaName, setAreaName] =  React.useState('');
    const [floorName, setFloorName] =  React.useState('');
    const [fileName, setFileName] = React.useState('');
    const [file, setFile] = React.useState([]);
    const [review, setReview] = React.useState(false);
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const validation = useSelector((state) => state.FileReducer.file);
    const uploadFileNoProcess = useUploadFileNoProcess();
    const uploadFile = useUploadFile();
    const fetchPolicyPdf = useFetchPolicyPdf();
    const loading = uploadFileNoProcess.isLoading || uploadFile.isLoading;
    const pdf = useSelector((state)=> state.FileReducer.PDFfile.file);
    const [pdfUrl, setPdfUrl] = React.useState(`${pdf}`);
    const [noProcess, setNoProcess] = React.useState(false);
    const [dFile, setDFile] = React.useState(true);

    React.useEffect(() => {
        fetchPolicyPdf.mutate({ pdfType: 1, setPdfUrl });
        if (validation.file.length > 0) {
            setReview(true)
        }
    }, [validation.file]);

    function showNamingValidationError() {
        const result = validatePlanNaming({ jobName, floorName });
        if (!result.ok) {
            swal({ text: result.message, icon: "error" });
            return true;
        }
        return false;
    }

    const handleUpload = () => {
        if (user.hasAcceptedUploadPolicy === 0) return;

        if ((noProcess || !dFile) && showNamingValidationError()) {
            return;
        }

        if (file.length < 1) {
            return Toast.fire({ title: 'File required', icon: 'error' });
        }
        if (!isWithinUploadLimit(file[0])) {
            return Toast.fire({ title: uploadSizeErrorMessage(), icon: 'error' });
        }

        if (noProcess) {
            if (customerSelect.userCompanyId === '00000000-0000-0000-0000-000000000000') {
                return swal({ text: 'Customer missing, please Assign a customer to proceed.', icon: 'error' });
            }
            uploadFileNoProcess.mutate(
                {
                    file: file[0],
                    name: fileName,
                    companyId: company.id,
                    customerId: customerSelect.userCompanyId,
                },
                {
                    onSuccess: () => {
                        setFile([]);
                        setJobName('');
                        setAreaName('');
                        setFloorName('');
                        setFileName('');
                        navigate(PLANS_PATH);
                    },
                },
            );
            return;
        }

        if (dFile || canProceedWithPlanNaming({ jobName, floorName })) {
            const resolvedName = dFile ? defaultNewPlanFileName() : fileName;
            setFileName(resolvedName);
            uploadFile.mutate({ file: file[0], name: resolvedName, companyId: company.id });
        } else {
            swal({ text: PLAN_NAMING_MESSAGES.jobAndFloorRequired, icon: 'error' });
        }
    };

    return (
        <Page title="Upload">
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden', minHeight: '100vh' }}>
                { company === undefined ?
                    <Alert severity="error" sx={{ m: 1, flexShrink: 0 }}>
                        Please create a company or ask your admin to invite you.
                    </Alert>
                    : null
                }
                { loading ? <LoadingReport/> : <Upload dFile={dFile} setDFile={setDFile} noProcess={noProcess} setNoProcess={setNoProcess} pdfUrl={pdfUrl} setPdfUrl={setPdfUrl}
                setJobName={setJobName} setAreaName={setAreaName} setFloorName={setFloorName} setFile={setFile} handleUpload={handleUpload} setFileName={setFileName}
                jobName={jobName} areaName={areaName} floorName={floorName}/> }
                <ReviewPage status={review} change={setReview}/>
            </Box>
        </Page>
    )
}

export default FileUploader;
